// 营业执照（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="center">
      <h1>营业执照</h1>
      <div class="copyImg"></div>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mCopyright"); //移动端跳转路由
    } else {
      this.$router.replace("/copyright"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
h1 {
  opacity: 1;
  font-size: 1rem;
  font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
  font-weight: 700;
  text-align: center;
  color: #4279db;
  line-height: 0.75rem;
  margin: 1rem 0;
}
.copyImg {
  width: 100%;
  height: 16rem;
  background: url("../../assets/img/首页/建协工程咨询营业执照.jpg") 0 0 no-repeat;
  background-size: 100%;
  margin: 0.5rem auto;
}
</style>
